import styled, { css } from 'styled-components';

interface TokenBoxProps {
  loading?: boolean;
}

export const Container = styled.div`
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Title = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  font-weight: 600;
  gap: 8px;
  font-size: 16px;
  line-height: 140%;

  color: ${props =>
    props.theme.darkMode ? props.theme.interface3 : props.theme.interface7};
`;

export const Text = styled.span`
  font-weight: 300;
  font-size: 16px;
  line-height: 140%;

  color: ${props => props.theme.interface5};
`;

export const TokenBox = styled.div<TokenBoxProps>`
  max-width: 480px;
  width: 100%;
  > div input {
    padding-right: 76px;
    letter-spacing: 1px;
  }

  svg {
    transition: color 0.1s ease-in;
  }

  ${props =>
    props.loading
      ? css`
          .icon {
            cursor: default;
          }
        `
      : css`
          svg:hover {
            color: ${props.theme.brand_primary_color};
          }
        `}
`;

export const ErrorBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;

  span {
    font-weight: 300;
    font-size: 14px;
    line-height: 140%;

    color: ${props => props.theme.errorNew};
  }
`;
